import React, { useEffect, useState } from 'react';
import Icon from './Icon';
import './BackToTop.css';

export default function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      className="backtotop"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="回到頂部"
    >
      <Icon name="arrowLeft" size={16} style={{ transform: 'rotate(90deg)' }} />
    </button>
  );
}
